import { __rest } from "tslib";
import { forwardRef } from 'react';
import { createReactWrapper } from '../common/PrefixUtils';
export const Typography = forwardRef((_a, ref) => {
    var { children, gutterBottom, gutterTop, lineClamp } = _a, props = __rest(_a, ["children", "gutterBottom", "gutterTop", "lineClamp"]);
    return createReactWrapper({
        tagName: 'chameleon-typography',
        props: Object.assign(Object.assign({}, props), { 'gutter-bottom': gutterBottom, 'gutter-top': gutterTop, 'line-clamp': lineClamp, ref }),
        children,
    });
});
